import React from "react";
import Hellosection from "./Hellosection";
import Whatsection from "./Whatsection";
import Winningsection from "./Winningsection";
import Gallerysection from "./Gallerysection";
import Registration_instruction from "./Registration_instruction";

import Calendarsection from "./Calendarsection";
const Body = ({hellosection,sectionSessionRef,whatsection,winningdata,gallerydata,setpapplydata,registrtion_setp_info}) => {
  return (
    <section>
   
        
        
        <Calendarsection sectionSessionRef={sectionSessionRef} setpapplydata={setpapplydata}/>
        <Registration_instruction registrtion_setp_info={registrtion_setp_info} />
           <Hellosection hellosection={hellosection} />
        <Whatsection whatsection={whatsection} />
        <Winningsection winningdata={winningdata} />
        <Gallerysection gallerydata = {gallerydata}/>
        
    </section>
  );
};

export default Body;